import React, { useContext } from "react";
import { useEffect } from "react";
import { Stat } from "@yy/yy-stat";
import { ChannelIdContext } from "../../components/ChannelIdContextWrap";

export const stat = new Stat({
  prodid: "yylive",
  param: {
    sys: "4",
    report_type: 0,
  },
});

// https://data.hiido.com/index.php?r=sdkdemand/eventview&id=20030927
export default function useHiidoPV(act_type: string) {
  useEffect(() => {
    stat.emit({
      eventid: 20030927,
      act_type: act_type,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return stat;
}

export const ExposeLandingPageHiidoPV = () => {
  const a = useContext(ChannelIdContext);

  useEffect(() => {
    stat.emit({
      ref: encodeURIComponent(document.referrer),
      eventid: 20030927,
      act_type: "001",
      more_info: { aisle_src_id: a },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
